import template from './notificationCard.html';
import controllerArray from './NotificationCardController';

function noCard() {
  return {
    template,
    restrict: 'E',
    transclude: true,
    controller: 'NotificationCardController',
    scope: {
      notification: '=',
      notifications: '='
    }
  };
}

function register(ngModule) {
  ngModule.controller('NotificationCardController', controllerArray);
  ngModule.directive('notificationCard', noCard);
}

export default register;
